import { render, staticRenderFns } from "./calendar-facet-highlight-text-color.vue?vue&type=template&id=2bead1e4&"
import script from "./calendar-facet-highlight-text-color.vue?vue&type=script&lang=js&"
export * from "./calendar-facet-highlight-text-color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports